export default __webpack_public_path__ + "static/media/change-password-confirm.f9f28633.png";